import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import {
  FaMobileAlt,
  FaLock,
  FaSearch,
  FaBolt,
  FaHeadset,
  FaTools,
  FaShieldAlt,
  FaShoppingCart
} from "react-icons/fa";

import "./featuresection.css";

function FeaturesSection() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

     const handleCall = () => {
    window.location.href = "tel:8778934301"; // opens phone dialer
  };

  const features = [
    { icon: <FaMobileAlt />, title: "Mobile Responsive" },
    { icon: <FaLock />, title: "Free SSL Certificate" },
    { icon: <FaSearch />, title: "SEO Optimized" },
    { icon: <FaBolt />, title: "Fast Loading Speed" },
    { icon: <FaHeadset />, title: "24/7 Support" },
    { icon: <FaTools />, title: "User-Friendly Admin Panel" },
    { icon: <FaShieldAlt />, title: "Advanced Security" },
    { icon: <FaShoppingCart />, title: "E-Commerce Ready" },
  ];

  return (
    <section className="features-section">
      <div className="container">
        <section className="section-margin">
          <div className="heading-for-all" data-aos="fade-up">
            <h2>Website Features</h2>
          </div>
        </section>

        {/* Grid for desktop */}
        <div className="features-grid desktop-view">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
            </div>
          ))}
        </div>

        {/* Swiper for mobile */}
        <div className="features-swiper mobile-view">
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={20}
            slidesPerView={1.2}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
          >
            {features.map((feature, index) => (
              <SwiperSlide key={index}>
                <div className="feature-card">
                  <div className="feature-icon">{feature.icon}</div>
                  <h3 className="feature-title">{feature.title}</h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="features-cta">
          <button className="choose-plan-btn" onClick={handleCall}>Get Started</button>
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
